// TODO remove this file and use GenericController

import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { APIPath, APIPathWithArguments } from 'src/js/api/route-path-index';
import { BaseController } from 'src/js/controller/base-controller';
import { NetworkErrorHandler } from 'src/js/controller/network-error-handler';
import { convertCSVStringToData } from 'src/js/helper/csv-helper';
import { StreamStatRequest } from 'src/js/model/api/request/stream-stat-request';
import { StreamSrtStatsResponse } from 'src/js/model/api/response/stream-srt-stats-response';
import { StreamRequest, StreamResponse } from 'src/js/pages/streaming/stream/stream-models';

export class StreamController extends BaseController {
  public getStreams(): Observable<StreamResponse[]> {
    return this.get$(APIPath.streams.list).pipe(pluck('data'));
  }

  public getStream(id: number): Observable<StreamResponse> {
    return this.get$(APIPathWithArguments(APIPath.streams.single, { id }));
  }

  public createStream(request: StreamRequest): Observable<StreamResponse> {
    return this.post$(APIPath.streams.list, request).pipe(pluck('data'));
  }

  public updateStream(request: StreamRequest): Observable<StreamResponse> {
    return this.put$(APIPathWithArguments(APIPath.streams.single, { isd: request.id }), request).pipe(pluck('data'));
  }

  public deleteStream(id: number): Observable<{}> {
    return this.delete$(APIPathWithArguments(APIPath.streams.single, { id }));
  }

  public getStats(
    id: string,
    request: StreamStatRequest,
    errorHandler?: NetworkErrorHandler,
  ): Observable<StreamResponse> {
    return this.get$(APIPathWithArguments(APIPath.streams.stats, { id }), request, {
      customErrorHandler: errorHandler,
    }).pipe(pluck('data'));
  }

  public getSRTStats(
    id: string,
    request: StreamStatRequest,
    errorHandler?: NetworkErrorHandler,
  ): Observable<StreamSrtStatsResponse[]> {
    return this.get$<string>(APIPathWithArguments(APIPath.streams.stats, { id }), request, {
      customErrorHandler: errorHandler,
    }).pipe(map((response: string) => convertCSVStringToData<StreamSrtStatsResponse>(response)));
  }

  public deleteStats(id: string): Observable<StreamResponse> {
    return this.delete$(APIPathWithArguments(APIPath.streams.stats, { id })).pipe(pluck('data'));
  }
}
